import React, { memo } from 'react';
import { NodeProps } from 'reactflow';

export const LineNodeFlow = memo(({ data }: NodeProps) => {
    return (
        <svg width={'1400'} height="3" xmlns="http://www.w3.org/2000/svg">
            <line
                x1="0"
                y1="1"
                x2="1400"
                y2="1.5"
                stroke="var(--mantine-color-primary-teal-react-flow)"
                strokeWidth="2"
                strokeDasharray="5,5"
            />
        </svg>
    );
});
